import { render, staticRenderFns } from "./PageColumnWithVisitorList.vue?vue&type=template&id=7ae2a471&lang=pug&"
import script from "./PageColumnWithVisitorList.vue?vue&type=script&lang=ts&"
export * from "./PageColumnWithVisitorList.vue?vue&type=script&lang=ts&"
import style0 from "./PageColumnWithVisitorList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports